import { Injectable } from '@angular/core';
import { jsPDF, jsPDFOptions } from "jspdf";
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class GenerarPdfDetalleCuotasService {

  COLOR_TEXT_TITLE = '#75b7b6';
  COLOR_BLACK = '#000000';
  COLOR_WHITE = '#FFFFFF';
  MARGIN_LEFT = 20;


  UTILS = new UtilsService();

  options: jsPDFOptions = {};

  doc:any;

  headers: any[] = [
    {name: 'NRO_FACTURA', prompt: 'Factura'},
    {name: 'CUOTA', prompt: 'Cuota'},
    {name: 'ESTADO', prompt: 'Estado'},
    {name: 'VENCIMIENTO', prompt: 'Vencimiento'},
    {name: 'CAPITAL', prompt: 'Capital'},
    {name: 'INTERES_FINANCIERO', prompt: 'IF'},
    {name: 'SEGURO_FINANCIERO', prompt: 'SF'},
    {name: 'INTERES_MGRACIA', prompt: 'Interes mes gracia'},
    {name: 'OTROS', prompt: 'Otros'},
    {name: 'VALOR_CUOTA', prompt: 'Valor_cuota'},
    {name: 'HONORARIO', prompt: 'HN'},
    {name: 'GASTO_COBRANZA', prompt: 'GC'},
    {name: 'INTERES_MORA', prompt: 'Interes mora'},
    {name: 'VALOR_PAGO', prompt: 'Total'},
  ]

  constructor() {
    
  }

  async generar(enc: any, det: any[]) {
    this.doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "letter",
      compress: true
    })
    
    this.doc.addImage({ imageData: 'assets/img/logo-credijamar.png', format: 'PNG', x: 90, y: 20, width: 50, height: 25 });

    this.doc.setFont("helvetica", 'normal', "bold");
    this.doc.setFontSize(16);
    this.doc.setTextColor(this.COLOR_TEXT_TITLE);
    this.doc.text('DETALLE DE CUOTAS', 110, 60, { align: 'center' });
    
    this.doc.setFontSize(9);
    this.doc.setTextColor(this.COLOR_BLACK);
    this.doc.text('Fecha de Generación: ' + this.UTILS.formatDate((new Date()).toString(), 'dd/MM/yyyy'), 110, 65, { align: 'center' });
    
    this.doc.setFont("helvetica", 'normal', "normal");
    this.doc.text('Nombre: ' + enc.NOMBRE.toUpperCase(), this.MARGIN_LEFT, 80, { align: 'left' });
    this.doc.text('Cedula: ' + enc.NRO_IDENTIFICACION, this.MARGIN_LEFT + 110, 80, { align: 'left' });
    
    this.doc.text(`Cuenta: ${enc.TIPO_CREDITO}-${enc.AGENCIA}-${enc.CUENTA}`, this.MARGIN_LEFT, 90, { align: 'left' });
    this.doc.text('Factura: ' + enc.factura, this.MARGIN_LEFT + 40, 90, { align: 'left' });
    this.doc.text('Nro. Cuotas: ' + det.length, this.MARGIN_LEFT + 80, 90, { align: 'left' });
    this.doc.text('Valor cuota: ' + this.UTILS.formatCurrency(enc.CUOTA), this.MARGIN_LEFT + 120, 90, { align: 'left' });
    
    this.doc.setFont("helvetica", 'normal', "normal");
    this.doc.setFontSize(7);
    this.doc.setTextColor(this.COLOR_BLACK);

    this.doc.text(`Leyenda => IF: Interes Financiero | SF: Seguro Financiero | HN: Honorario | GC: Gastos por Cobranza`, this.MARGIN_LEFT, 98, { align: 'left' });

    det.map(i => {
      i.VENCIMIENTO = this.UTILS.formatDate(i.VENCIMIENTO, 'dd/MM/yyyy');
      i.CAPITAL = this.UTILS.formatCurrency(i.CAPITAL);
      i.INTERES_FINANCIERO = this.UTILS.formatCurrency(i.INTERES_FINANCIERO);
      i.SEGURO_FINANCIERO = this.UTILS.formatCurrency(i.SEGURO_FINANCIERO);
      i.INTERES_MGRACIA = this.UTILS.formatCurrency(i.INTERES_MGRACIA);
      i.OTROS = this.UTILS.formatCurrency(i.OTROS);
      i.VALOR_CUOTA = this.UTILS.formatCurrency(i.VALOR_CUOTA);
      i.HONORARIO = this.UTILS.formatCurrency(i.HONORARIO);
      i.GASTO_COBRANZA = this.UTILS.formatCurrency(i.GASTO_COBRANZA);
      i.INTERES_MORA = this.UTILS.formatCurrency(i.INTERES_MORA);
      i.VALOR_PAGO = this.UTILS.formatCurrency(i.VALOR_PAGO);
      return i;
    })

    var headers = this.createHeaders(this.headers);
    this.doc.table(this.MARGIN_LEFT, 100, det, headers, { autoSize: true, fontSize: 7, padding: 1, headerBackgroundColor: this.COLOR_TEXT_TITLE, headerTextColor: this.COLOR_WHITE, margins: {left: 0, bottom: 15, width: 0 , top: 15}});
    //this.doc.table(this.MARGIN_LEFT-2, 100, data, headers, { autoSize: true, fontSize: 7, padding: 1, headerBackgroundColor: this.COLOR_TEXT_TITLE, headerTextColor: this.COLOR_WHITE});
    
    let pageCount = this.doc.internal.getNumberOfPages();
    for(let i = 1; i<=pageCount; i++){
      this.doc.setPage(i);
      this.addHeader();
      this.addFooter();
    }
    this.doc.save('DetalleCuotas-'+enc.factura);
    //this.doc.output('dataurlnewwindow', {filename: 'Autorizacion Debito'});

  }

  createHeaders(keys: any[]) {
    let result: any[] = [];
    keys.forEach(k => {
      result.push({
        id: k.name,
        name: k.name,
        prompt: k.prompt,
        align: 'center',
      })
    })
    return result;
  }

  

  addHeader() {
    this.doc.addImage({
      imageData: 'assets/img/cabecera.png',
      format: 'PNG',
      x: 0,
      y: 0,
      //width: 210,
      width: 230,
      height: 80
    });
  }

  addFooter() {
    this.doc.addImage({
      imageData: 'assets/img/cabecera.png',
      format: 'PNG',
      x: 220,
      y: 120,
      //width: 210,
      width: 235,
      height: 80,
      rotation: 180
    });
  }

  addTable(x: number, y: number, data: any[], header: any[]) {
    this.doc.table(x, y, data, header, {});
  }


}